import { deviceType } from "@tm/isomorphic-utils";
import { fontSize, theme } from "@tm/utility/global";
import styled, { keyframes } from "styled-components";

const mobileAnim = keyframes`
    0% {
        /* top: -100vh; */
        bottom: -100%;
        opacity: 0;
    }
    100% {
        bottom: 0;
        opacity: 1;
    }
`;

export const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

// TODO: Check z-index and make it some specific value across repo
export const EmailSelectorBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.4);
  z-index: 9999;
  display: flex;
  align-items: flex-end;
`;
export const SelectorWrapper = styled.div`
  background: ${theme.whiteText};
  border-radius: 12px;
  box-shadow: 0 4px 32px rgba(0, 0, 0, 0.18);
  position: relative;

  @media ${deviceType.desktop} {
    min-width: 340px;
    max-width: 400px;
  }

  @media ${deviceType.mobile} {
    border-radius: 16px 16px 0 0;
    box-sizing: border-box;
    width: 100%;
    max-height: 80vh;
    overflow-y: auto;
    position: fixed;
    left: 0;
    bottom: -100%;
    z-index: 10;
    animation-fill-mode: forwards;
    animation: ${mobileAnim} 0.3s ease-in-out;
    animation-fill-mode: forwards;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  font-size: ${fontSize.font24};
  color: ${theme.greyText7};
  cursor: pointer;
`;

export const SelectorLabel = styled.label`
  font-weight: 600;
  font-size: ${fontSize.font18};
  margin-bottom: 4px;
  display: block;
`;

export const SelectorDescription = styled.div`
  background-color: #f4ebe5;
  color: ${theme.greyText};
  padding: 5px 11px 5px 11px;
  font-size: ${fontSize.font12};

  @media ${deviceType.mobile} {
    padding: 8px 24px;
  }
`;

export const InputWrapper = styled.div`
  font-size: ${fontSize.font14};
  display: flex;
  align-items: center;
  background: ${theme.whiteText2};
  padding: 0 12px;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
  height: 44px;

  @media ${deviceType.mobile} {
    border-radius: 16px;
    margin: 16px 24px;
    border: 1px solid var(--tm-accent-color);
    background-color: var(--tm-accent-bg-color);
  }
`;

export const InputIcon = styled.span`
  font-size: ${fontSize.font20};
  color: ${theme.greyText2};
  margin-right: 8px;
  display: flex;
  align-items: center;
`;

export const TravellerInput = styled.input`
  border: none;
  background: transparent;
  outline: none;
  font-size: ${fontSize.font16};
  flex: 1;
  color: ${theme.blackText2};
  height: 40px;
`;

export const Dropdown = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GroupSection = styled.div`
  margin-top: 16px;
`;

export const GroupLabel = styled.div`
  font-size: ${fontSize.font14};
  color: ${theme.greyText7};
  font-weight: 600;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const SectionDivider = styled.div`
  height: 1px;
  background: ${theme.gainsBoro};
  margin: 12px 0 8px 0;
`;

export const OptionRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s, border 0.15s;
  &:hover {
    background: var(--tm-accent-bg-color);
  }
`;

export const Dot = styled.span<{ color: string }>`
  width: 4px;
  height: 20px;
  border-radius: 10px;
  display: inline-block;
  margin-top: 3px;
  background: ${({ color }) => color || theme.greyText6};
`;

export const OptionContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Name = styled.span`
  font-weight: 600;
  font-size: ${fontSize.font16};
  color: ${theme.blackText2};
`;

export const Badge = styled.span<{ color: string }>`
  background: ${theme.whiteText};
  color: ${({ color }) => color || theme.greyText6};
  font-size: ${fontSize.font12};
  font-weight: 700;
  border-radius: 6px;
  padding: 2px 8px;
  margin-left: 8px;
`;

export const OptionEmail = styled.div`
  font-size: ${fontSize.font14};
  color: ${theme.greyText7};
  margin-top: 2px;
`;

export const Email = styled.div`
  font-size: ${fontSize.font14};
  color: ${theme.greyText7};
  margin-left: auto;
`;

export const Description = styled.div`
  font-size: ${fontSize.font14};
  color: ${theme.greyText2};
  margin-top: 2px;
`;

export const ColleagueTitle = styled.div`
  font-size: ${fontSize.font14};
  color: ${theme.greyText7};
  margin-top: 2px;
  margin-left: 16px;
`;

export const NoUserFoundMessage = styled.div`
  background-color: ${theme.gainsBoro};
  color: ${theme.greyText6};
  padding: 20px;
  text-align: center;
  font-size: ${fontSize.font14};
  border-radius: 6px;
  margin: 8px;
`;
